import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  id: "footer-container",
  ref: "refPCFooter"
};
const _hoisted_2 = {
  class: "base-info"
};
const _hoisted_3 = {
  class: "info-font"
};
const _hoisted_4 = {
  class: "config-info"
};
const _hoisted_5 = ["href"];
import { BEIAN_URL } from '@/constant/url/icp';
export default /*@__PURE__*/Object.assign({
  name: 'Footer'
}, {
  __name: 'index',
  props: {
    baseInfo: {
      type: Object,
      default: () => ({
        email: null,
        address: null,
        copyright: null,
        weixin: null,
        icp: null,
        domain: null
      })
    }
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("ul", null, [_cache[0] || (_cache[0] = _createElementVNode("li", null, "联系我们", -1)), _createElementVNode("li", null, "邮箱：" + _toDisplayString(__props.baseInfo.email), 1), _createElementVNode("li", null, "地址：" + _toDisplayString(__props.baseInfo.address), 1)])])]), _createElementVNode("div", _hoisted_4, [_createElementVNode("ul", null, [_createElementVNode("li", null, [_createElementVNode("a", {
        href: _unref(BEIAN_URL),
        target: "_blank",
        rel: "noopener noreferrer"
      }, _toDisplayString(__props.baseInfo.icp), 9, _hoisted_5)])])])], 512);
    };
  }
});